/* tslint:disable */
/* eslint-disable */
/**
 * V2M Backend API
 * Backend API for the V2M multi-brand platform (word2mail, koe2mail, sprich2mail, ...) - handles authentication, quota management, and LLM requests
 *
 * The version of the OpenAPI document: 1.0.5
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { MailTriageRecordFromJSON, MailTriageRecordToJSON } from './MailTriageRecord';
/**
 * Check if a given object implements the MailTriageListResponse interface.
 */
export function instanceOfMailTriageListResponse(value) {
    if (!('records' in value) || value['records'] === undefined)
        return false;
    return true;
}
export function MailTriageListResponseFromJSON(json) {
    return MailTriageListResponseFromJSONTyped(json, false);
}
export function MailTriageListResponseFromJSONTyped(json, _ignoreDiscriminator) {
    if (json == null) {
        return json;
    }
    return {
        'nextCursor': json['next_cursor'] == null ? undefined : json['next_cursor'],
        'records': (json['records'].map(MailTriageRecordFromJSON)),
    };
}
export function MailTriageListResponseToJSON(json) {
    return MailTriageListResponseToJSONTyped(json, false);
}
export function MailTriageListResponseToJSONTyped(value, _ignoreDiscriminator = false) {
    if (value == null) {
        return value;
    }
    return {
        'next_cursor': value['nextCursor'],
        'records': (value['records'].map(MailTriageRecordToJSON)),
    };
}
